const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    invisibleButton: {
      position: 'relative',
      background: 'transparent',
      width: 'fit-content',
      height: 'fit-content',
      padding: 0,
      border: 'none',
      '&:hover, &:active, &:focus': {
        background: 'transparent',
      },
      '&.ant-btn[disabled]': {
        background: 'none',
        filter: 'brightness(0.3)',
      },
    },
    stickerAmount: {
      color: 'white',
      transform: 'translate(-6px, 0px)',
      fontSize: '11px',
    },
    emojiPanelContainer: {
      padding: 20,
    },
    emojiListRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(76px, 1fr))',
      gridGap: 10,
    },
    emojiGridCell: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      width: '80px',
    },
    priceSection: {
      transform: 'translate(-6px, -14px)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    diamondImage: {
      height: '19px',
      zIndex: '10',
    },
    priceTag: {
      background: '#ADADADB5',
      borderRadius: '7px',
      color: 'white',
      fontSize: '10px',
      padding: '1px 10px',
      transform: 'translateX(-7px)',
    },
    disabledEffect: {
      pointerEvents: 'none',
      filter: 'brightness(0.3)',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
